// @flow
import React from 'react';
import {FormattedMessage} from 'react-intl';
import CSSTransition from 'react-transition-group/CSSTransition';

import './SearchHereButton.less';
import {LoadingOverlay} from '@homeaway/react-loading-overlay';

export type SearchHereButtonProps = {
    isVisible: boolean,
    onClick: Function,
    shouldDisableSearchButton: boolean,
    isLoading: boolean
};

const SearchHereButton = ({
    isVisible,
    onClick,
    shouldDisableSearchButton,
    isLoading
}: SearchHereButtonProps) => (
    <div>
        <CSSTransition
            in={isVisible}
            classNames="Map__searchHere__transition"
            timeout={400}
            mountOnEnter
            unmountOnExit
        >
            <div className="Map__search" data-wdio="Map__search">
                <button
                    key="searchhereShow"
                    type="button"
                    className="btn btn-primary"
                    onClick={onClick}
                    data-wdio="Map__search"
                    disabled={shouldDisableSearchButton}
                >
                    <FormattedMessage
                        id="searchHere"
                        description="Search Here"
                        defaultMessage="Search Here"
                    />
                </button>
            </div>
        </CSSTransition>
        <LoadingOverlay loading={isLoading} />
    </div>
);

export default SearchHereButton;
